"use client";

import { motion } from "framer-motion";

const features = [
  {
    icon: "timer",
    title: "Hours to minutes",
    description:
      "What used to take your team hours now takes minutes of review.",
  },
  {
    icon: "fact_check",
    title: "Accurate across every form type",
    description:
      "Our models are fine-tuned on the latest tax laws. We handle your work better than junior associates.",
  },
  {
    icon: "chat",
    title: "Talk to the founders directly",
    description:
      "No support tickets. Get the direct phone line of the founders and engineers building your workflow for 24/7 support.",
  },
];

export function FeaturesGrid() {
  return (
    <section id="features" className="pt-20 sm:pt-32 pb-16 sm:pb-24 px-4 sm:px-8 max-w-7xl mx-auto bg-landing-bg">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="text-center mb-16"
      >
        <h2 className="text-4xl md:text-5xl font-serif font-bold tracking-tight text-landing-text">
          Built for how you actually work.
        </h2>
      </motion.div>
      <div className="grid md:grid-cols-3 gap-8">
        {features.map((feature, i) => (
          <motion.div
            key={feature.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.6 }}
            className="group bg-white p-10 rounded-3xl hover:-translate-y-2 transition-all duration-300 shadow-sm hover:shadow-xl border border-landing-surface/20"
          >
            <div className="mb-8">
              <span className="material-symbols-outlined text-4xl text-landing-primary">
                {feature.icon}
              </span>
            </div>
            <h3 className="text-2xl font-bold mb-4">{feature.title}</h3>
            <p className="text-landing-text-secondary leading-relaxed">{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
